import { DOCUMENT, inject, Service } from '@angular/core';
import { Subject } from 'rxjs';

@Service()
export class OnyxPopoverService {
  private readonly document = inject(DOCUMENT);

  private _added$ = new Subject<Element>();
  public get added$() {
    return this._added$.asObservable();
  }

  private _removed$ = new Subject<Element>();
  public get removed$() {
    return this._removed$.asObservable();
  }

  constructor() {
    this.document.addEventListener(
      'toggle',
      ({ target }) => {
        if (!(target instanceof Element)) return;
        if (!(
          target instanceof HTMLDialogElement || target.hasAttribute('popover')
        )) {
          return;
        }

        if (
          target.matches(':modal, :popover-open') &&
          this.document.contains(target)
        ) {
          this._added$.next(target);
        } else {
          this._removed$.next(target);
        }
      },
      { capture: true },
    );
  }
}
